// client/src/services/analyticsService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

const buildQuery = (params) => {
  const q = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');
  return q ? `?${q}` : '';
};

const get = async (path, params = {}) => {
  const response = await fetch(`${apiUrl}/analytics/${path}${buildQuery(params)}`, {
    headers: authHeaders()
  });
  checkUnauthorized(response);
  if (!response.ok) throw new Error("Erreur lors du chargement des données d'analyse.");
  return await response.json();
};

const analyticsService = {
  getSummary: (params) => get('summary', params),
  getCategories: (params) => get('categories', params),
  getMonthly: (params) => get('monthly', params),
  getBudgets: (params) => get('budgets', params),
  getSubscriptions: (params) => get('subscriptions', params)
};

export default analyticsService;
